import React from 'react';
import { Trans } from 'react-i18next';
import Tip from 'components/Common/Template/Tip';

export const TabHome = () => {
  return (
    <>
      <div className="content">
        <div className="tab img-area home" />
        <div className="left-wrap">
          <div className="wrapper">
            <div className="large-title">
              <Trans i18nKey="BTY_W_T_SETUP_MAIN_PAGE" />
            </div>
          </div>
          <div className="large-text">
            <Trans i18nKey="BTY_W_T_SELECT_MAINPAGE" />
          </div>
        </div>
      </div>
      <Tip subText=<Trans i18nKey="BTY_W_T_MAIN_PAGE_INFO" /> />
    </>
  );
};

export default TabHome;
